import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@taro/design/fonts'
import '@taro/design/styles'

import { Atmosphere } from '@taro/design'
import '@taro/ink/css'
import { InkProvider } from '@taro/ink/react'

import { App } from './App'

// Атмосфера — рядом с App, а не внутри: она обязана быть на экране
// в любом состоянии приложения, включая загрузку и ошибку. Пустой экран
// с туманом читается как «ещё не открылось», плоский чёрный — как «сломалось».
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Atmosphere />
    {/* Сид на сессию: закрыл и открыл заново — другой почерк чернил.
        Цвета берутся из ролей темы, поэтому переходы перекрашиваются
        вместе с ней и модуль об этом ничего не знает. */}
    <InkProvider speed={0.6} colors={{ glow: 'var(--c-arcane-bg)' }}>
      <App />
    </InkProvider>
  </StrictMode>,
)
